import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleList from './components/ArticleList';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleList />
        <StatsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}